import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { GlobalProvider } from "./context/GlobalContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import io from "socket.io-client";

const queryClient = new QueryClient();
const socket = io(process.env.REACT_APP_SOCKET_SERVER_URL);

const root = ReactDOM.createRoot(document.getElementById("root"));
document.title = process.env.REACT_APP_TITLE ? process.env.REACT_APP_TITLE : "Select";

root.render(
  <QueryClientProvider client={queryClient}>
    <GlobalProvider>
      <App socket={socket} />
    </GlobalProvider>
  </QueryClientProvider>
);
